export const copy = {
  scrambleGlyphs: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  play: "Play",
  pause: "Pause",
  mute: "Mute",
  unmute: "Unmute",
  reelLabel: "Lusion showreel",
  emailInvalid: "Please enter a valid email address.",
  newsletterPreview:
    "Thanks for your interest! This is a demo. Visit the original site to subscribe.",
  backToTop: "Back to home",
};

// 与中文 HTML 对应的完整文本节点；保留原有标签和动画结构。
export const pageCopy = {
  切换到英文: "Switch to English",
  "Lusion｜让想象成为可探索的世界":
    "Lusion | Make imagination an explorable world",
  "以三维叙事、动态设计与交互开发，让想象成为可以探索的数字世界。":
    "Turning imagination into explorable digital worlds through 3D storytelling, motion design and creative development.",
  返回首页: "Back to home",
  返回: "Back",
  切换背景音乐: "Toggle background music",
  聊聊你的想法: "Let's talk",
  打开菜单: "Open menu",
  菜单: "Menu",
  关闭: "Close",
  首页: "Home",
  关于我们: "About us",
  精选作品: "Featured work",
  联系我们: "Contact us",
  订阅我们的: "Subscribe to",
  灵感来信: "our newsletter",
  请输入邮箱地址: "Enter your email address",
  提交邮箱地址: "Submit email address",
  创意实验室: "Creative labs",
  "以三维叙事与交互体验，让品牌的想象力被看见":
    "We bring brands to life through 3D storytelling and interactive experiences",
  "向下滚动，开始探索": "Scroll to explore",
  "大胆想象，": "Dream boldly.",
  让灵感成真: "Make it real.",
  "将设计、动态、三维与开发融为一体，创造令人驻足的数字体验。从一次品牌发布，到一个可以自由探索的世界，让每一次互动都留下印象。":
    "We combine design, motion, 3D and development to create digital experiences that draw people in. From a brand launch to a world you can explore, we make every interaction memorable.",
  探索我们的创作方式: "Explore our approach",
  播放作品短片: "Play our showreel",
  观看作品短片: "Watch our showreel",
  "为敢于想象的品牌与团队，创造值得探索的数字世界。":
    "Digital worlds worth exploring, created for brands and teams with bold imaginations.",
  "创意 · 网站 · 设计 · 开发 · 三维 · 动画":
    "Concept · Web · Design · Development · 3D · Animation",
  "欧瑞佐 · 智能创想": "Oryzo AI",
  "阿特拉斯 · 动态之境": "Atlas Motion",
  "网站 · 设计 · 开发 · 三维": "Web · Design · Development · 3D",
  "德文 · 智能协作": "Devin AI",
  "网站 · 设计 · 开发 · 三维 · 动画":
    "Web · Design · Development · 3D · Animation",
  橡木之境: "Of The Oak",
  永续流动: "Everswap",
  "创意 · 三维插画 · 动态设计 · 影像":
    "Concept · 3D illustration · Motion design · Film",
  "保时捷：造梦机器": "Porsche: Dream Machine",
  合成人类: "Synthetic Human",
  "元宇宙：空间融合": "Meta: Spatial Fusion",
  "网站 · 设计 · 开发 · 三维 · 链上体验":
    "Web · Design · Development · 3D · Web3",
  数字藏品空间: "Spaace - NFT Marketplace",
  "数字设计大会 2024": "DDD 2024",
  "创意 · 网站 · 游戏设计 · 三维": "Concept · Web · Game design · 3D",
  呜呜列车世界: "Choo Choo World",
  "增强现实 · 开发 · 三维": "AR · Development · 3D",
  苏打奇遇: "Soda Experience",
  探索全部作品: "Explore all projects",
  让创意成为身临其境的体验: "Ideas become immersive experiences",
  "每个品牌都有独特的表达。我们用鲜明的视觉语言与自然的互动，让品牌被理解，让观众愿意停留，让体验成为记忆。":
    "Every brand has a unique voice. Through distinctive visuals and intuitive interaction, we help people connect with brands, stay curious and remember the experience.",
  "从创意方向、三维制作到交互开发，我们细致打磨每一个环节，为你的想法构建完整而独特的数字旅程。":
    "From creative direction and 3D production to interactive development, we craft every detail to turn your idea into a complete and distinctive digital journey.",
  踏入全新的世界: "Step into a new world",
  让你的想象: "and let your",
  自由驰骋: "imagination run wild",
  "准备好，让下一个大胆想法启程了吗？":
    "Ready to bring your next bold idea to life?",
  让我们一起: "Let's work",
  "创造精彩！": "together!",
  继续向下探索: "Keep exploring",
  二号工作室: "Studio 2",
  "马什街 9 号": "9 Marsh Street",
  "布里斯托尔 · BS1 4AA": "Bristol · BS1 4AA",
  英国: "United Kingdom",
  关注动态: "Twitter / X",
  视觉日记: "Instagram",
  领英: "LinkedIn",
  一般咨询: "General enquiries",
  商务合作: "Business enquiries",
  "©2026 LUSION 创意工作室": "©2026 LUSION Ltd",
  "创意研发：labs.lusion.co": "R&D: labs.lusion.co",
  "由 Lusion 用心创作 ❤️": "Made with love by Lusion ❤️",
  继续滚动: "Keep scrolling",
  回到旅程起点: "to start again",
  回到首页: "Back to home",
  重新探索: "Explore again",
  关闭短片: "Close showreel",
  播放: "Play",
  静音: "Mute",
  正在加载三维世界: "Loading the 3D world",
};
